import { useState } from 'react';
import { PageHeader } from '../../components/page-header';
import { OrderSplitTab } from './order-split-tab';
import { RevenueTab } from './revenue-tab';
import { SummaryTab } from './summary-tab';

// Reports, all gated on `report.financial`:
//   Revenue      company / seller / delivery-partner split by day, week, month
//   Order split  the same split for each delivered order, product by product
//   Summary      sales / operations / finance KPIs over a rolling window

const TABS = [
  { key: 'revenue', label: 'Revenue' },
  { key: 'orders', label: 'Order split' },
  { key: 'summary', label: 'Summary' },
] as const;
type TabKey = (typeof TABS)[number]['key'];

export function ReportsPage() {
  const [tab, setTab] = useState<TabKey>('revenue');

  return (
    <div className="space-y-6">
      <PageHeader
        title="Reports"
        description="What customers paid for delivered orders, and how it splits between the company, sellers and delivery partners"
      />
      <div role="tablist" aria-label="Report sections" className="tabs">
        {TABS.map((t) => (
          <button key={t.key} type="button" role="tab" aria-selected={tab === t.key} onClick={() => setTab(t.key)} className="tab">
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'revenue' && <RevenueTab />}
      {tab === 'orders' && <OrderSplitTab />}
      {tab === 'summary' && <SummaryTab />}
    </div>
  );
}
